import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import DatePicker from "react-datepicker";

import { TimePicker } from 'react-ios-time-picker';

import "react-datepicker/dist/react-datepicker.css";

import {
    create, update, retrieve
} from "./actions/sjfFAQs";
export default function SJFFAQs_add(props) {
    const dispatch = useDispatch();
    const InitialData = {
        faq_id: '',
        type: '',
        question: '',
        answer: '',
    };
    const InitialErrData = {
        res: 1,
        key: '',
        msg: ''
    };
    const [createModalVisibility, setCreateModalVisibility] = useState(false);
    const [oldProp, setOldProp] = useState({});
    const [startDate, setStartDate] = useState(new Date());
    const [formData, setFormData] = useState((props && props.is_edit && props.props && props.props.faq_id) ? props.record_data : InitialData);
    const [errData, setErrData] = useState(InitialErrData);

    useEffect(() => {
        // console.log("oldProp", oldProp, "props", props)
        if (props && props.is_edit && props.props && props.props.faq_id) {
            setCreateModalVisibility(true);
            setFormData({
                faq_id: props.props.faq_id,
                type: props.props.record_data.type,
                question: props.props.record_data.question,
                answer: props.props.record_data.answer,
            })
        } else {
            setCreateModalVisibility(false);
            setFormData(InitialData)
        }
    }, [oldProp, props]);

    let handleCreateModalVisibility = () => {
        setCreateModalVisibility(!createModalVisibility);
        // if (props.callingExternal)
        props.updateParentState(false)
    }


    let handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }



    let isNumeric = (value) => {
        return /^-?\d+$/.test(value);
    }

    let isAlphaNumeric = (value) => {
        return /^[a-zA-Z0-9 ]*$/.test(value);
    }

    let isText = (value) => {
        return /^[a-zA-Z ]*$/.test(value);
    }

    let isEmail = (value) => {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
    }

    let validationHandler = () => {
        let response = { res: 1, msg: 'Validated.' };
        // if(formData?.type === undefined || formData?.type === '' || formData?.type === '')
        //     response = {res: 0, key: 'type', msg: 'FAQs name is required.'};
        // if(formData?.question === undefined || formData?.question === '' || formData?.question === '')
        //     response = {res: 0, key: 'question', msg: 'FAQs name is required.'};
        // if(formData?.answer === undefined || formData?.answer === '' || formData?.answer === '')
        //     response = {res: 0, key: 'answer', msg: 'FAQs name is required.'};
        return response;
    }

    let handleSave = () => {
        let validation_response = validationHandler();
        if (validation_response.res === 0) {
            setErrData(validation_response)
        } else {
            if (formData?.faq_id == undefined || formData?.faq_id == '' || formData?.faq_id.length == 0)
                dispatch(create(formData)).then((response) => {
                    if (response.data.key)
                        setErrData(response.data)
                    else {
                        setOldProp(props);
                        alert(response.data.msg);
                        props.updateParentState(false)
                        setCreateModalVisibility(false);
                        let data = {
                            limit: 10,
                            last_faq_id: '',
                            first_faq_id: '',
                        };
                        dispatch(retrieve(data)).then(() => { });
                    }
                });
            else
                dispatch(update(formData)).then((response) => {
                    if (response.data.key)
                        setErrData(response.data)
                    else {
                        setOldProp(props);
                        alert(response.data.msg);
                        props.updateParentState(false)
                        setCreateModalVisibility(false);
                        let data = {
                            limit: 10,
                            last_faq_id: '',
                            first_faq_id: '',
                        };
                        dispatch(retrieve(data)).then(() => { });
                    }
                });
        }
    }
    // console.log("props", props.props, (props && props.props && props.props.faq_id)?1:0);


    return (
        <>
            <div className="card">
                <div className="card-body">
                    <div className="card-header">
                        <h4 className="card-title">{(props && props.is_edit) ? 'Update' : 'Add'} FAQs</h4>
                        <button className="btn-close" type="button" aria-label="Close" data-bs-dismiss="modal" onClick={handleCreateModalVisibility}></button>
                    </div>
                    <div className="card-body">
                        <form>
                            <div className='form-group'>
                                <label>FAQs type</label>
                                <input type='text' className='form-control' placeholder='Enter FAQs Type' name='type' value={formData?.type} onChange={handleChange} />
                                {/* <select type='text' className='form-select' name='type' value={formData?.type} onChange={handleChange} >
                                    </select> */}
                                {(errData.res == 0 && errData.key == 'type') ?
                                    <small className='err-msg'><i className='fas fa-exclamation-triangle'></i> {errData.msg}</small>
                                    : ''}
                            </div>
                            <div className='form-group'>
                                <label>Question</label>
                                <input type='text' className='form-control' placeholder='Enter FAQs Question' name='question' value={formData?.question} onChange={handleChange} />
                                {(errData.res == 0 && errData.key == 'question') ?
                                    <small className='err-msg'><i className='fas fa-exclamation-triangle'></i> {errData.msg}</small>
                                    : ''}
                            </div>
                            <div className='form-group'>
                                <label>Answer</label>
                                <textarea type='text' className='form-control' placeholder='Enter FAQs Answer   ' name='answer' value={formData?.answer} onChange={handleChange} ></textarea>
                                {(errData.res == 0 && errData.key == 'answer') ?
                                    <small className='err-msg'><i className='fas fa-exclamation-triangle'></i> {errData.msg}</small>
                                    : ''}
                            </div>
                        </form>
                    </div>
                    <div className="card-footer">
                        <button className="btn btn-light" type="button" data-bs-dismiss="modal" onClick={handleCreateModalVisibility}>Close</button>
                        <button className="btn btn-primary" type="button" onClick={handleSave}>{(props && props.is_edit) ? 'Update' : 'Save'}</button>
                    </div>
                </div>
            </div>
        </>
    )
}
